import React from 'react';
import classes from './Industries.module.scss'
import {Link} from "react-router";
import { useTranslation } from 'react-i18next';


const Industries = () => {
    const { t } = useTranslation();

    const industriesBlocks = t('strategicIt.industriesBlocks', {returnObjects: true});

    return (
        <div className={classes.container}>
        <div className={classes.blocks}>
            {industriesBlocks.map(({image, text, link}) => <Link key={link} to={link}>
                <img alt={text} src={require(`./images/${image}`)} className={classes["image"]}/>
                <span>{text}</span>
            </Link>)}
        </div>
        </div>
    );
};

export default Industries;